export default __webpack_public_path__ + "static/media/441.d596ef76.jpg";